// extracted by mini-css-extract-plugin
export default {"modal":"DeleteProductionTypeModal_modal__U96S8","placeHolderShimmer":"DeleteProductionTypeModal_placeHolderShimmer__ndJkx"};